import { RcFile } from 'antd/lib/upload';

import { ExchangeDependency } from '../../../gamma-api';

export const buildDependenciesFile = (dependencies: ExchangeDependency[]): RcFile => {
  const json = JSON.stringify(dependencies);

  const file = new File([json], 'dependencies.json', {
    type: 'application/json',
  });

  return file as RcFile;
};

export const hasActiveDependencies = (dependencies: ExchangeDependency[], count: number): boolean => {
  let result = 0;
  for (const dependency of dependencies) {
    if (!dependency.object_code) {
      continue;
    }

    result++;
    if (result > count) {
      return true;
    }
  }
  return false;
};
